import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
export default function extractQuantityFieldsFromProduct(product) {
  var _ref = product || {},
      quantityDefault = _ref.quantityDefault,
      quantityMax = _ref.quantityMax,
      quantityMin = _ref.quantityMin,
      quantityStep = _ref.quantityStep,
      unit = _ref.unit;

  return Object.entries({
    quantityDefault: quantityDefault,
    quantityMax: quantityMax,
    quantityMin: quantityMin,
    quantityStep: quantityStep,
    unit: unit
  }).reduce(function (r, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        k = _ref3[0],
        v = _ref3[1];

    return v ? _extends({}, r, _defineProperty({}, k, v)) : r;
  }, {});
}